import { SearchLimitLeftModel } from '@/types/home';
import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import styles from './index.module.less';
import Image from 'next/image';
import { useUserProvider } from '@/context/UserProvider';

interface FreeTimesProps {
  leftModel: SearchLimitLeftModel;
  onUnlimitedClick: () => void;
  /** 访客的使用情况，未登录试用 */
  guestUsage?: SearchLimitLeftModel;
  onLoginClick?: () => void;
}

const FreeTimes: React.FC<FreeTimesProps> = ({ leftModel, onUnlimitedClick, guestUsage, onLoginClick }) => {
  const { isLogin } = useUserProvider();
  const { t } = useTranslation();

  const getTimeUntilUTCMidnight = () => {
    const now = new Date();
    const utcNow = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
    const tomorrow = new Date(utcNow);
    tomorrow.setUTCHours(24, 0, 0, 0);

    const diffMs = tomorrow.getTime() - utcNow.getTime();
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    return `${hours}h ${minutes}m`;
  };

  if (!leftModel || leftModel?.un_limit) {
    return null;
  }

  if (guestUsage && !isLogin) {
    return (
      <div className="pt-8 flex justify-center items-center gap-12 text-sm">
        <div className="space-x-1 font-medium">
          <span>{t('Free Viewer limit:')}</span>
          <span style={{ color: guestUsage?.search_limit > 0 ? '#38C13D' : '#FF6464' }}>
            {guestUsage?.search_limit ?? 0}/1
          </span>
        </div>
        {guestUsage?.search_limit === 0 && (
          <div>
            <span style={{ color: '#725CFF', cursor: 'pointer' }} onClick={onLoginClick}>
              {t('Sign up to get more')}
            </span>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={styles.timesDesc}>
      <div className={styles.item}>
        <span>{t('Free Viewer limit:')}</span>
        <span style={{ color: leftModel?.search_limit > 0 ? '#38C13D' : '#FF6464' }}>
          {leftModel?.search_limit ?? 0}/1
        </span>
      </div>
      <div className={styles.item}>
        <span>{t('Free download limit:')}</span>
        <span style={{ color: leftModel?.download_limit > 0 ? '#38C13D' : '#FF6464' }}>
          {leftModel?.download_limit ?? 0}/3
        </span>
      </div>
      <div className={styles.item}>
        <Image src={'/images/landingpage/down_time_icon.webp'} alt={''} width={16} height={16} />
        <span style={{ color: '#666666' }}>
          {t('Updated in')} {getTimeUntilUTCMidnight()}
        </span>
      </div>
      <div className={styles.item}>
        <span style={{ color: '#725CFF', cursor: 'pointer' }} onClick={onUnlimitedClick}>
          {t('Get unlimited')}
        </span>
      </div>
    </div>
  );
};

export default FreeTimes;
